import PropTypes from 'prop-types';
import styles from './FJHeadshotHistoryItem.module.less';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJDeleteWhiteIcon from '../../../../assets/svg/delete-white.svg?react';
import FJDownloadIcon from '../../../../assets/svg/download.svg?react';
import FJImage from '../../../../common/components/FJImage/FJImage';
import classNames from 'classnames';
import FJCheckBox from '../../../../common/components/FJCheckBox/FJCheckBox';
import FJTextWithEllipsisParent from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsisParent';
import FJUtil from '../../../../util/FJUtil';
import { useMemo } from 'react';
import FJHeadshotGeneratorConfig from '../../../../config/appConfig/FJHeadshotGeneratorConfig';
import FJVersionConfig from '../../../../config/FJVersionConfig';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip';

const FJHeadshotHistoryItem = ({
    item,
    onClick,
    onDelete,
    onDownload,
    isSelected,
    onSelect,
    isLoading,
    isError,
    isMultipleMode,
}) => {
    const handleClick = () => {
        onClick?.(item);
    };

    const handleSelect = (checked, e) => {
        e.stopPropagation();
        onSelect?.(item.eventId);
    };

    const handleDelete = e => {
        e.stopPropagation();
        onDelete?.(item.eventId);
    };

    const handleDownload = e => {
        e.stopPropagation();
        onDownload?.(item.eventId);
    };

    const previewImageList = useMemo(() => {
        return item.headshotList?.filter(item => item.status === 'succeeded').slice(0, 3);
    }, [item.headshotList]);

    if (isLoading) {
        return (
            <div className={styles.history_item}>
                <div className={styles.item_content}>
                    <div className={classNames(styles.aspect_ratio_box, styles.loading)}>
                        <div className={styles.generation_animation}>
                            <video
                                src={`${FJHeadshotGeneratorConfig.generatingPlaceholderVideoUrl}mobius-gray.mp4?v=${FJVersionConfig.staticPathVersion}`}
                                autoPlay
                                loop
                                muted
                                disablePictureInPicture
                            />
                        </div>
                        <div className={styles.generation_info}>
                            <h4>{FJLocalStore._('photo-generating')}</h4>
                            <p>{FJLocalStore._('it-takes-a-moment')}</p>
                        </div>
                    </div>
                </div>
                <div className={styles.item_info}>
                    <div className={styles.item_title}>{item.name}</div>
                    <div className={styles.create_time}>{FJUtil.convertToCurrentTimezone(item.createTime)}</div>
                </div>
            </div>
        );
    }

    if (isError) {
        return (
            <div className={styles.history_item}>
                <div className={styles.item_content}>
                    <div className={classNames(styles.aspect_ratio_box, styles.error)}>
                        <div className={styles.error_placeholder}>{FJLocalStore._('generation-failed')}</div>
                    </div>
                </div>
                <div className={styles.item_info}>
                    <div className={styles.item_title}>{item.name}</div>
                    <div className={styles.create_time}>{FJUtil.convertToCurrentTimezone(item.createTime)}</div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.history_item} onClick={handleClick}>
            <div className={styles.item_content}>
                <div className={styles.aspect_ratio_box}>
                    {item.headshotList && item.headshotList.length > 0 ? (
                        previewImageList.map((result, index) => (
                            <FJImage
                                key={index}
                                isShowLoading
                                imgClassName={styles.result_image}
                                boxClassName={styles.result_image_box}
                                imgSrc={result.imgUrl}
                                alt={FJLocalStore._('headshot-preview')}
                            />
                        ))
                    ) : (
                        <div className={styles.image_placeholder}>{FJLocalStore._('no-image')}</div>
                    )}
                </div>

                {item.headshotList && item.headshotList.length > 0 && (
                    <div className={styles.file_count_tag}>
                        <div className={styles.text}>
                            {item.headshotList.length} {FJLocalStore._('files')}
                        </div>
                    </div>
                )}

                <div className={classNames(styles.selection_checkbox, isMultipleMode && styles.active)}>
                    <FJCheckBox selected={isSelected} dataChange={handleSelect} />
                </div>

                <div className={styles.image_actions} style={{ visibility: isMultipleMode ? 'hidden' : 'visible' }}>
                    <FJToolTip title={FJLocalStore._('delete')}>
                        <div className={styles.delete_button} onClick={handleDelete}>
                            <FJDeleteWhiteIcon />
                        </div>
                    </FJToolTip>
                    <FJToolTip title={FJLocalStore._('download')}>
                        <div className={styles.download_button} onClick={handleDownload}>
                            <FJDownloadIcon />
                        </div>
                    </FJToolTip>
                </div>
            </div>

            <div className={styles.item_info}>
                <FJTextWithEllipsisParent text={item.name} className={styles.item_title} />
                <div className={styles.create_time}>{FJUtil.convertToCurrentTimezone(item.createTime)}</div>
            </div>
        </div>
    );
};

FJHeadshotHistoryItem.propTypes = {
    item: PropTypes.object,
    onClick: PropTypes.func,
    onDelete: PropTypes.func,
    onDownload: PropTypes.func,
    isSelected: PropTypes.bool,
    onSelect: PropTypes.func,
    isLoading: PropTypes.bool,
    isError: PropTypes.bool,
    isMultipleMode: PropTypes.bool,
};

export default FJHeadshotHistoryItem;
